import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components';
import { ClientErrorCodes, LicenseEnvironment, LicenseFormControl, LicenseType, OfflineState, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { FileUploadService } from '@services';
import { BehaviorSubject, Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var ActivateOfflineModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ActivateOfflineModalComponent, _super);
    function ActivateOfflineModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.OfflineState = OfflineState;
        _this.LicenseFormControl = LicenseFormControl;
        _this.editPermission = [];
        _this.isHost = false;
        _this.hasFile$ = new BehaviorSubject(OfflineState.UNDETERMINED);
        _this.file = null;
        _this.progress = 15;
        _this.hasValidLicense = OfflineState.YES;
        _this._appState = _this._injector.get(AppStateFacade);
        _this._translateService = _this._injector.get(TranslateService);
        _this._fileUploadService = _this._injector.get(FileUploadService);
        _this._destroyed$ = new Subject();
        return _this;
    }
    ActivateOfflineModalComponent.prototype.ngOnInit = function () {
        var _a;
        var _this = this;
        this.context.data = {
            installationId: this.context.data.installationId,
            licenseKey: '',
            environment: LicenseEnvironment.Production,
            update: this.context.data.update,
        };
        this.formGroup = this._injector.get(FormBuilder).group((_a = {},
            _a[LicenseFormControl.installationId] = [
                this.context.data.installationId,
            ],
            _a[LicenseFormControl.licenseKey] = [
                this.context.data.licenseKey,
                Validators.required,
            ],
            _a[LicenseFormControl.environment] = [
                this.context.data.environment,
            ],
            _a));
        this.serviceUrl = this._appState.settings.get(Setting.serviceUrl);
        this.hasFile$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (hasFile) {
            switch (hasFile) {
                case OfflineState.UNDETERMINED:
                    _this.progress = 30;
                    break;
                case OfflineState.NO:
                    _this.progress = 60;
                    break;
                case OfflineState.YES:
                case OfflineState.GENERATE:
                    _this.progress = 90;
                    break;
            }
        });
    };
    ActivateOfflineModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    Object.defineProperty(ActivateOfflineModalComponent.prototype, "fileName", {
        get: function () {
            return this.file ? this.file.name : '';
        },
        enumerable: true,
        configurable: true
    });
    ActivateOfflineModalComponent.prototype.clipboardCopied = function () {
        this._snack.success(this._translateService.instant('global_message_copied_clipboard'));
    };
    ActivateOfflineModalComponent.prototype.onClear = function () {
        this.file = null;
    };
    ActivateOfflineModalComponent.prototype.onFileChange = function (files) {
        this.file = files[0];
    };
    ActivateOfflineModalComponent.prototype.generate = function () {
        var payload = {
            installationId: this.context.data.installationId,
            licenseKey: this.formGroup.get(LicenseFormControl.licenseKey).value,
            environment: this.formGroup.get(LicenseFormControl.environment).value,
        };
        this.customEvent.emit({
            type: 0 /* Generic */,
            data: payload,
        });
    };
    ActivateOfflineModalComponent.prototype.onSubmit = function () {
        if (!this._fileUploadService.isFileItemValid(this.file, null, 102400)) {
            if (this.file) {
                this._snack.error(this._translateService.instant('settings_license_form_upload_invalid_warning') + " (#" + ClientErrorCodes.InvalidLicenseFormat + ")");
            }
            return;
        }
        this._dialogRef.close({
            type: 1 /* Add */,
            additionalData: {
                file: this.file,
                type: LicenseType.UiPath,
            },
        });
    };
    return ActivateOfflineModalComponent;
}(UiModalComponent));
export { ActivateOfflineModalComponent };
